import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d80986e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container user-container" }
const _hoisted_2 = { class: "title-block" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "main-title" }, "用户管理", -1))
const _hoisted_4 = { class: "total-text" }
const _hoisted_5 = { class: "biz-card order-table" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_9 = { style: {"text-align":"center"} }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", null, [
        _createVNode(_component_el_form, {
          inline: "true",
          onsubmit: "return false"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.searchform.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchform.name) = $event)),
                  placeholder: "请输入用户名或邮箱",
                  onChange: _ctx.searchUser,
                  onKeyup: _withKeys(_ctx.searchUser, ["enter"])
                }, null, 8, ["modelValue", "onChange", "onKeyup"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, "共 " + _toDisplayString(_ctx.total) + " 条记录", 1),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", null, [
        _withDirectives(_createVNode(_component_el_table, {
          data: _ctx.tableList,
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "用户姓名",
              prop: "realName"
            }),
            _createVNode(_component_el_table_column, {
              label: "邮箱",
              prop: "userName"
            }),
            _createVNode(_component_el_table_column, {
              label: "所属项目组",
              prop: "realName"
            }, {
              default: _withCtx((scope) => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.userGroup, (item) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: item.id
                  }, [
                    (item.proGroupName != null)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(item.proGroupName) + ",", 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_7, "-"))
                  ]))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "用户角色",
              prop: ""
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.roles ?? "-"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "操作" }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_popover, {
                  visible: scope.row.isShowPop,
                  placement: "top",
                  width: 400,
                  trigger: "click"
                }, {
                  reference: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "text",
                      onClick: ($event: any) => (_ctx.openPop(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_form, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "所属项目组：" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                multiple: "",
                                clearable: "",
                                modelValue: _ctx.dialogForm.userProGroupArr,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialogForm.userProGroupArr) = $event))
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupList, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.id,
                                      label: item.proGroupName,
                                      value: item.id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: ($event: any) => {
                        _ctx.setGroup(scope.row.userId);
                        scope.row.isShowPop = false;
                      }
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_el_button, {
                          onClick: ($event: any) => {
                        _ctx.dialogForm.userProGroupArr = [];
                        scope.row.isShowPop = false;
                      }
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["visible"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]), [
          [_directive_loading, _ctx.loading]
        ])
      ])
    ])
  ]))
}